const bg = "_bg_1y38p_8";
const drawer = "_drawer_1y38p_17";
const body = "_body_1y38p_51";
const drawerMenu = {
  bg,
  drawer,
  body
};
export {
  bg,
  body,
  drawerMenu as default,
  drawer
};
//# sourceMappingURL=DrawerMenu.module.css.js.map
